import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/FoodPreferences/FoodPreferencesStep.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// FOOD PREFERENCES STEP
// Reuses the --c-*/--sp-*/--r-sm/--t-fast custom properties that
// AssessmentStepShell.styles.js's <Section> scopes over the whole step —
// this file never redeclares them, same as every other step's styles file.
// ═══════════════════════════════════════════════════════════════════════════════

export const FieldGroup = styled.div`
  margin-bottom: var(--sp-6);
`;
FieldGroup.displayName = "FieldGroup";

export const FieldLabel = styled.label`
  display: block;
  color: var(--c-text);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: var(--sp-2);
`;
FieldLabel.displayName = "FieldLabel";

export const RequiredMark = styled.span`
  color: ${DIET_C.accent};
  margin-left: 2px;
`;
RequiredMark.displayName = "RequiredMark";

export const HelperValue = styled.span`
  color: var(--c-text-muted);
  font-weight: 500;
`;
HelperValue.displayName = "HelperValue";

// ─── Diet type — single-select cards (hard filter) ─────────────────────────
export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--sp-3);

  @media (max-width: 60em) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;
CardGrid.displayName = "CardGrid";

export const DietTypeCard = styled.button`
  min-height: 64px;
  padding: var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  border: 2.4px solid ${({ $active }) => ($active ? DIET_C.primary : `${DIET_C.secondary}66`)};
  transition: border-color var(--t-fast);

  &:hover {
    border-color: ${DIET_C.primary};
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent);
    outline-offset: 2px;
  }
`;
DietTypeCard.displayName = "DietTypeCard";

// ─── Cuisine — multi-select chips (soft preference) ────────────────────────
export const ChipGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
`;
ChipGrid.displayName = "ChipGrid";

export const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: 999px;
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: 2.4px solid ${({ $active }) => ($active ? DIET_C.primary : `${DIET_C.secondary}66`)};
  transition: border-color var(--t-fast);

  &:hover {
    border-color: ${DIET_C.primary};
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent);
    outline-offset: 2px;
  }
`;
Chip.displayName = "Chip";

// ─── Cooking time — dropdown (hard filter) ──────────────────────────────────
export const Select = styled.select`
  width: 100%;
  height: 44px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  border: 1px solid ${DIET_C.secondary}88;
  transition: border-color var(--t-fast);

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
Select.displayName = "Select";

// ─── Budget — slider (hard filter) ──────────────────────────────────────────
export const RangeInput = styled.input.attrs({ type: "range" })`
  width: 100%;
  accent-color: ${DIET_C.primary};
`;
RangeInput.displayName = "RangeInput";

export const RangeScaleRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: var(--sp-2);
`;
RangeScaleRow.displayName = "RangeScaleRow";

export const RangeScaleItem = styled.span`
  color: ${({ $active }) => ($active ? DIET_C.primary : "var(--c-text-muted)")};
`;
RangeScaleItem.displayName = "RangeScaleItem";